import * as ACTION from '../constants';
import * as saga from './saga';
import {takeLatest} from 'redux-saga/effects';

export default function* () {
    yield takeLatest(ACTION.FETCH_DETAIL_WAREHOUSE_STAFF.REQUEST, saga.getDetailWarehouseStaff);
    yield takeLatest(ACTION.FETCH_DETAIL_WAREHOUSE_STAFF.FAILED, saga.getDetailWarehouseStaffFailed);
}